import StudentVideoLibrary from "../../components/SPanel/StudentVideoLibrary";

function SPVideos() {
   return (
      <main className="main">
         <section className="page-wrapper">
            <StudentVideoLibrary />
         </section>
      </main>
   );
}

export default SPVideos;
